import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Navbar.scss';

const Navbar: React.FC = () => {
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="navbar__container">
        <Link to="/" className="navbar__logo">
          RSVP
        </Link>

        <div className="navbar__menu">
          {isAuthenticated ? (
            <>
              <Link to="/dashboard" className="navbar__link">
                Dashboard
              </Link>
              <Link to="/events" className="navbar__link">
                Events
              </Link>
              <span className="navbar__user">{user?.email}</span>
              <button onClick={handleLogout} className="navbar__button">
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/rsvp" className="navbar__link">
                RSVP
              </Link>
              <Link to="/login" className="navbar__link">
                Login
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
